'use client';
import React, { useEffect, useState } from 'react';

interface TypewriterTextProps {
  words: string[];
  className?: string;
  speed?: number;
  deleteSpeed?: number;
  pauseTime?: number;
}

export default function TypewriterText({
  words,
  className = '',
  speed = 100,
  deleteSpeed = 60,
  pauseTime = 2000,
}: TypewriterTextProps) {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) {
      const timeout = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
      }, pauseTime);
      return () => clearTimeout(timeout);
    }

    const currentWord = words[currentWordIndex];

    if (!isDeleting) {
      if (currentText.length < currentWord.length) {
        const timeout = setTimeout(() => {
          setCurrentText(currentWord.slice(0, currentText.length + 1));
        }, speed);
        return () => clearTimeout(timeout);
      } else {
        setIsPaused(true);
      }
    } else {
      if (currentText.length > 0) {
        const timeout = setTimeout(() => {
          setCurrentText(currentText.slice(0, -1));
        }, deleteSpeed);
        return () => clearTimeout(timeout);
      } else {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    }
  }, [currentText, isDeleting, isPaused, currentWordIndex, words, speed, deleteSpeed, pauseTime]);

  return (
    <span data-component-id="src/components/ui/TypewriterText.tsx:58:4" data-component-path="src/components/ui/TypewriterText.tsx" data-component-line="58" data-component-end-line="61" data-component-file="TypewriterText.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" className={className}>
      {currentText}
      <span data-component-id="src/components/ui/TypewriterText.tsx:60:6" data-component-path="src/components/ui/TypewriterText.tsx" data-component-line="60" data-component-end-line="60" data-component-file="TypewriterText.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22animate-blink%20text-primary%22%2C%22textContent%22%3A%22%7C%22%7D" className="animate-blink text-primary">|</span>
    </span>
  );
}
